// extracted by mini-css-extract-plugin
module.exports = {"tab":"tabs_tab__1MLgy","label":"tabs_label__tXCL3","title":"tabs_title__2ZKCo","icon":"tabs_icon__1BfD7","tabPanel":"tabs_tabPanel__CMWEO"};